import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import queryClient from "@/core/queryClient";
import { Synonym, Page } from "@/model";
import synonymRepository from "@/repository/synonymRepository";
import { synonymQueryKeys } from "./keys";


const getData = async (agentId: number, page: number, size: number, order: 'asc' | 'desc', keyword?: string) => {
    const response = await synonymRepository.find(agentId, page, size, order, keyword);
    return response.data.data;
};

export const usePaginatedSynonyms = (agentId: number, page: number, size: number, order: 'asc' | 'desc', keyword?: string) => {
    return {
        ...useQuery<Page<Synonym>, AxiosError>({
            queryKey: ["page-synonym", "agent", agentId, "page", page, "size", size, "order", order, "keyword", keyword],
            queryFn: async () => await getData(agentId, page, size, order, keyword),
            retry: false
        }),
        invalidate: () => queryClient.invalidateQueries({ queryKey: synonymQueryKeys.all(agentId) })
    };
};
